<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  authComputed,
  siteListMethod,
  studentListMethod,
  userListMethod,
  departmentListMethod,
  departmentComputed,
} from '@state/helpers'

export default {
  page: {
    title: 'Add Student',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'b-overlay': BOverlay,
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      studentError: null,
      studentDataStatus: false,
      isStudentError: false,
      isLoading: false,
      editorData: '',
      image: '',
      show: false,
      siteconfiglist: [],
      collegelist: [],
      classlist: [],
      classlistData: [],
      platformId: 0,
      platform: '',
      collegeId: null,
      collegeClass: null,
      departmentId: null,
      departmentlist: [],
    }
  },
  computed: {
    ...authComputed,
    ...departmentComputed,
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
  },
  mounted() {
    if (this.role === 'admin') {
      this.getListOfPlatform()
      this.getColleges()
    } else {
      this.platformId = this.profileData.platform_id
    }
    this.getDepartments()
    if (this.role === 'college') {
      this.collegeId = this.profileData.college_id
    } else if (this.role === 'teacher') {
      this.collegeClass = this.profileData.collegeClass
    } else if (this.role === 'administrator') {
      this.getColleges()
    }
  },
  methods: {
    ...siteListMethod,
    ...studentListMethod,
    ...userListMethod,
    ...departmentListMethod,
    addStudentData() {
      this.isLoading = true
      if (this.platformId === '') {
        const Data = {
          first_name: this.firstName,
          last_name: this.lastName,
          email: this.email,
          phone: this.phone,
          status: false,
          department: this.departmentId,
          college_id: this.collegeId,
          collegeClass: this.collegeClass,
        }
        this.addStudent({ Data })
          .then((resp) => {
            this.isLoading = false
            this.$router.push({ name: 'student.list' })
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.studentError = getError.message
            this.isStudentError = true
            window.scrollTo(0, 0)
          })
      } else {
        const Data = {
          first_name: this.firstName,
          last_name: this.lastName,
          email: this.email,
          phone: this.phone,
          status: false,
          department: this.departmentId,
          platform_id: this.platformId,
          platform: this.platform,
          college_id: this.collegeId,
          collegeClass: this.collegeClass,
        }
        this.addStudent({ Data })
          .then((resp) => {
            this.isLoading = false
            this.$router.push({ name: 'student.list' })
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.studentError = getError.message
            this.isStudentError = true
          })
      }
    },

    // get list of platform
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          // listitems.push({value:'All', text: 'All'})
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },

    getRole() {
      if (this.platformId === 0) {
        this.collegeId = 0
      } else {
        this.collegeId = this.platformId
      }
      let i = 0
      for (i = 0; i < this.siteconfiglist.length; i++) {
        if (this.platformId === this.siteconfiglist[i].value) {
          this.platform = this.siteconfiglist[i].text
          this.collegeName = this.siteconfiglist[i].text
        }
      }
    },

    getClasses() {
      this.fetchClassList()
        .then((classes) => {
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select Class',
            disabled: true,
          })
          classes.forEach((element) => {
            var ele = {}
            if (this.departmentId === element.department) {
              ele.text = element.name
              ele.value = element._id
              ele.college = element.college_id
              listitems.push(ele)
            }
          })
          this.classlist = listitems
        })
        .catch((_error) => {})
    },

    getDepartments() {
      this.departmentId = null
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select Department',
            disabled: true,
          })
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },

    getColleges() {
      this.collegeId = null
      this.fetchCollegeList()
        .then((college) => {
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select College',
            disabled: true,
          })
          college.forEach((element) => {
            if (element.platform_id === this.platformId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.collegelist = listitems
        })
        .catch((_error) => {})
    },

    selectClass() {
      this.classlist = []
      this.collegeClass = null
      var i = 0
      this.classlist.push({
        value: null,
        text: 'Select Class',
        disabled: true,
      })
      for (i = 0; i < this.classlistData.length; i++) {
        if (this.classlistData[i].college === this.collegeId) {
          this.classlist.push({
            value: this.classlistData[i].value,
            text: this.classlistData[i].text,
          })
        }
      }
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.firstName.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          event.charCode === 32
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },

    restrictChars1(event) {
      if (event.charCode === 32 && !this.lastName.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          event.charCode === 32
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },

    restrictChars2(event) {
      if (event.charCode === 32 && !this.email.length) {
        event.preventDefault()
      } else {
        if (event.charCode !== 32) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card>
            * Mandatory Fields<br /><br />
            <b-alert
              v-model="isStudentError"
              variant="danger"
              v-html="studentError"
            ></b-alert>
            <b-form
              data-parsley-validate
              novalidate
              @submit.prevent="addStudentData"
            >
              <b-form-group label="First Name*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="firstName"
                  type="text"
                  placeholder="Enter First Name"
                  @keypress="restrictChars($event)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Last Name*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="lastName"
                  type="text"
                  placeholder="Enter Last Name"
                  @keypress="restrictChars1($event)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Email Id*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="email"
                  type="text"
                  placeholder="Enter Email"
                  @keypress="restrictChars2($event)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Phone Number*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="phone"
                  type="number"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  maxlength="12"
                  placeholder="Enter Phone Number(with country code)"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                v-if="role === 'admin'"
                label="Select Platform*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="platformId"
                  :options="siteconfiglist"
                  @change="getColleges"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                v-if="role === 'administrator' || role === 'admin'"
                label="Select College*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="collegeId"
                  :options="collegelist"
                  @change="getDepartments"
                ></b-form-select>
              </b-form-group>
              <b-form-group label="Select Department*" label-for="input-1">
                <b-form-select
                  v-model="departmentId"
                  :options="departmentlist"
                  @change="getClasses"
                ></b-form-select>
              </b-form-group>
              <b-form-group label="Select Class*" label-for="input-1">
                <b-form-select
                  v-model="collegeClass"
                  :options="classlist"
                ></b-form-select>
              </b-form-group>

              <b-form-group id="button-group" class="mt-4">
                <b-button
                  v-if="!isLoading"
                  type="submit"
                  variant="primary"
                  style="color: white"
                  >Save</b-button
                >
                <b-button
                  v-else
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  disabled
                >
                  <b-spinner small></b-spinner>Loading...
                </b-button>
              </b-form-group>

              <a class="cancel-anchor" href="/student-list"
                ><b-button
                  v-if="!isLoading"
                  class="cancel"
                  type="button"
                  variant="primary"
                  >Cancel</b-button
                ></a
              >
            </b-form>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.cancel {
  background-color: grey;
}
.cancel:hover {
  background-color: grey !important;
}
.cancel:active {
  background-color: grey !important;
}

.cancel-anchor {
  color: white !important;
}
.cancel-anchor:hover {
  color: white;
}
.vue-tags-input {
  max-width: 100% !important;
}

.ti-new-tag-input-wrapper input {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
}
.ti-tag::before {
  display: none;
}
[class^='ti-'],
[class*=' ti-'] {
  font-size: inherit !important;
  font-weight: inherit !important;
}
</style>
